import {Record} from 'immutable';

export class Address extends Record<{
    city?: string | null;
    zip?: string | null;
    street?: string | null;
    country?: string | null;
    state?: string | null;
    countryInput?: string | null;
}>({
    city: null,
    zip: null,
    street: null,
    country: null,
    state: null,
    countryInput: null,
}) {}

export const getCountryAndState = (address: Address | undefined) => {
    if (!address) {
        return {};
    }

    // If the country is 'US', we need to include the state in the request as well
    if (address.country === 'US') {
        return {
            country: address.country,
            state: address.state,
        };
    }
    // If the country is 'Other', we send whatever is put in the country text input as value for the dentist AddressCountry'
    else if (address.country === 'Other') {
        return {
            country: address.countryInput,
            state: undefined,
        };
    }
    // Otherwise, we just send the country
    else {
        return {
            country: address.country,
            state: undefined,
        };
    }
};
